module.exports = __webpack_public_path__ + "img/horizontal_1_1_1.4a48a0b0.png";